import "./styles.css";
import { getCocktails, getCocktail } from "./cocktails.js";
import {
    populateCocktaislList,
    createCurrentCocktailCard,
    handleModal,
} from "./createDom.js";

async function initializeApp() {
    const cocktailsJson = await getCocktails();     
    if (cocktailsJson && cocktailsJson.data) {
        populateCocktaislList(cocktailsJson.data);
        handleModal(cocktailsJson.data);

        if (cocktailsJson.data.length > 0) {
            const firstCocktail = await getCocktail(cocktailsJson.data[0].id);
            if (firstCocktail?.data) {
                createCurrentCocktailCard(firstCocktail.data);
            }
        }
    } else {
        console.error("Failed to load cocktails data.");
    }
}

initializeApp();

